import { useEffect, useState } from "react";
import { clubApi } from "../api/club.service";
import { ClubType, PagingType } from "../types";

export const useGetList = (initialParams?: Record<string, any>) => {
  const [params, setParams] = useState<Record<string, any>>(
    initialParams || {}
  );
  const [data, setData] = useState<ClubType[]>([]);
  const [paging, setPaging] = useState<PagingType | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);

  const fetchData = async (fetchParams: Record<string, any>) => {
    try {
      setLoading(true);

      const response: any = await clubApi.findAll(fetchParams);

      setData(response?.data?.data?.data ?? []);
      setPaging(response?.data?.data?.paging ?? null);

      return true;
    } catch (err: any) {
      console.log("Get clubs failed:", err);

      setError(err.message || "Something wrong");

      return false;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(params);
  }, [JSON.stringify(params)]);

  return {
    data,
    fetchData,
    paging,
    loading,
    error,
    params,
    setParams,
  };
};
